/* eslint 'no-array-constructor': 'off', 'no-loop-func' : 'off', eqeqeq: 'off'  */
import React, { Component } from 'react';
import { Row, Col, Button, FormGroup, Label, Table, Modal } from 'reactstrap';
import {FaQuestionCircle} from 'react-icons/fa';
import { Redirect } from 'react-router-dom';
import { connect } from 'react-redux';
import * as ErrorMessage from '../../../../../../Resources/ErrorMessages';
import ErrorGif from '../../../../../../Assets/images/Error.gif';
import SelectAllCheckboxes from '../../../../../../Resources/SelectAllCheckboxes';
import Conversions from '../../../../../../Resources/Conversions';
import Currencies from '../../../../../../Resources/Currencies';
import DeleteConfirmation from '../../_ModalsForms/DeleteConfirmation';
import classnames from 'classnames';
import { SaveFixedChargesforclient } from '../../../../../../action/manageTenantAction';
import { getAllResources } from '../../../../../../action/cultureAction';

let IsEdit = false;
class Tenants_FixedRates extends Component {
    componentDidMount(){
        if(this.props.getLabels["ManageTenants.Create.Text"] === undefined){
            this.props.getAllResources();
        }
        if(this.props.ClientSideFixedChargesState != undefined && this.props.ClientSideFixedChargesState != null){
            let Data = this.props.ClientSideFixedChargesState;
            this.setState({fixed_charges: Data});
        }
    }
    constructor(props) {
        super(props);
        this.state = {
            modal: false,
            deletemodal: false,
            redirect: false,
            redirectBack: false,
            error_msg: false,
            Select_error_msg: false,
            fixed_charges: [],
            FixedChargeDetails: [],
            selected_fixedrates : new Array()
        };
        this.toggle = this.toggle.bind(this);
        this.goNext = this.goNext.bind(this);
        this.goBack = this.goBack.bind(this);
        this.onAddFixedCharge = this.onAddFixedCharge.bind(this);
        this.ViewFixedRtDetails = this.ViewFixedRtDetails.bind(this);
        this.Deletetoggle = this.Deletetoggle.bind(this);
    }

    ViewFixedRtDetails(Id, Name, Rate) {
        var EditFixedChargeDetails = [];
        EditFixedChargeDetails.push({ Index: Id, fixedChargeName: Name, fixedRate: Rate });
        IsEdit = true;
        this.setState({
            modal: true, FixedChargeDetails: EditFixedChargeDetails, error_msg: false
        });
    }

    onAddFixedCharge() {
        this.setState({ error_msg: false });
        var lstFixedCharges = this.state.fixed_charges;
        var IndexVal;
        if (IsEdit) {
            IndexVal = this.state.FixedChargeDetails[0].Index;
            lstFixedCharges = lstFixedCharges.filter(el => el.Index != IndexVal);
        }
        else {
            if(lstFixedCharges.length){
                for(var i=0;i<lstFixedCharges.length; i++){
                    lstFixedCharges[i].Index = i;
                }
            }
            IndexVal = (lstFixedCharges.length) + 1;
        }


        var Data = {
            "Index": IndexVal,
            "fixedChargeName": this.refs.FixedName.value,
            "fixedRate": (this.refs.FixedRate.value == null || this.refs.FixedRate.value == "") ? 0 : parseFloat(this.refs.FixedRate.value).toFixed(2)
        };
        if (Data.fixedChargeName == "" || Number.isNaN(Number(this.refs.FixedRate.value))) {
            this.setState({ error_msg: true });
        } else {
            lstFixedCharges.push(Data);
            this.setState({ fixed_charges: lstFixedCharges, modal: false });
        }
    }

    DeleteFixedCharges() {
        this.setState({ Select_error_msg: false });
        var Data = new Array();
        var checkboxes = document.getElementsByClassName('fixedRt_child_check_box');
        for (var i = 0; i < checkboxes.length; i++) {
            if (checkboxes[i].checked === true) {
                var fixedCharge_ID_to_be_deleted = {
                    "Index": checkboxes[i].id
                }
                Data.push(fixedCharge_ID_to_be_deleted);
            }

        }
        if (Data.length > 0) {
            this.setState({ Select_error_msg: false, selected_fixedrates: Data });
            this.Deletetoggle();
        }
        else {
            this.setState({ Select_error_msg: true });
        }
    }

    Delete = (returnVal) => {
        if (returnVal == "yes") {
            var Data = this.state.selected_fixedrates;
            var lstFixedCharges = this.state.fixed_charges;
            for(var i=0; i<Data.length; i++){
                lstFixedCharges = lstFixedCharges.filter(el => el.Index != Data[i].Index);
            }
            this.setState({ selected_fixedrates: new Array(), fixed_charges: lstFixedCharges });
        }
        this.Deletetoggle();
    }

    goBack() {
        this.props.SaveFixedChargesforclient(this.state.fixed_charges);
        this.setState({ redirectBack: true });
    }
    goNext(e) {
        this.props.SaveFixedChargesforclient(this.state.fixed_charges);
        this.setState({ redirect: true });
    }
    toggle() {
        IsEdit = false;
        this.setState({
            modal: !this.state.modal,
            FixedChargeDetails: [], 
            error_msg: false
        });
    }
    Deletetoggle() {
        this.setState({
          deletemodal: !this.state.deletemodal
        });
    }
    render(ClientSideComapnyState, ClientSideFixedChargesState, getLabels, UserPreference_response) {
        if (this.state.redirect) {
            return <Redirect to={"/managetenant/ConfirmTenantSettings"} />
        }
        if (this.state.redirectBack) {
            if (this.props.ClientSideComapnyState != undefined) {
                if (this.props.ClientSideComapnyState.HasMeter)
                    return <Redirect to={"/managetenant/TenantMeters"} />
                else {
                    if (this.props.ClientSideComapnyState.HasAfterHrs)
                        return <Redirect to={"/managetenant/TenantEmployeeUsers"} />
                    else
                        return <Redirect to={"/managetenant/CreateTenant"} />
                }
            }
        }
        let label = this.props.getLabels;
        let data, fixedCharges, Error_Message = null, Select_Error_Message = null, CurrencySym = '$', Header = label['FixedRateSetup.AddFixedRate.Text'], FxName = null, FxRate = null;
        data = this.state.fixed_charges;

        let PreferedDateFormat = this.props.UserPreference_response;

        var CompanyData = this.props.ClientSideComapnyState;
        if (CompanyData != undefined && CompanyData != null && CompanyData != "") {
            CurrencySym = Currencies.CurrencySymbol(CompanyData.CurrencyId);
        }

        if (data != undefined) {
            fixedCharges = data.map(el => (
                <tr>
                    <td><input type="checkbox" key={el.Index} id={el.Index} className="fixedRt_child_check_box" onClick={() => { SelectAllCheckboxes.ResetHeaderCheckBox("fixedRt_child_check_box", "FixedRt_header_Check_box"); }} /></td>
                    <td onClick={() => { this.ViewFixedRtDetails(el.Index, el.fixedChargeName, el.fixedRate) }} style={{ color: '#6890C6' }} className="link_cursor">{el.fixedChargeName}</td>
                    <td style={{"font-family":"Arial"}}> {CurrencySym + " " + Conversions.formatNumber(PreferedDateFormat,el.fixedRate)}</td>
                </tr>
            ));
            if(fixedCharges.length === 0){
                fixedCharges =<tr>
                <td colSpan="4">{label['NoRecords.Text']}</td>
                </tr>
            }
        }
        if (IsEdit && this.state.FixedChargeDetails != null && this.state.FixedChargeDetails.length) {
            FxName = this.state.FixedChargeDetails[0].fixedChargeName;
            FxRate = this.state.FixedChargeDetails[0].fixedRate;
            Header = 'Edit Fixed Charge';
        }

        (this.state.error_msg == true) ? Error_Message = <p className="error_msg"> <img src={ErrorGif} alt="Trane Logo" />  {ErrorMessage.changeLimits_error}</p> : Error_Message = " ";
        (this.state.Select_error_msg == true) ? Select_Error_Message = <p className="error_msg"> <img src={ErrorGif} alt="Trane Logo" />  {ErrorMessage.Fixed_charges_error}</p> : Select_Error_Message = " ";

        return (
            <div className="EnsembleCreateTenant">
                <Row>
                    <Col sm={{ size: 1, offset: 11 }} className="text-right" >
                        <FaQuestionCircle className="Ensemble_Icon Ensemble_question_Icon" />
                    </Col>
                </Row>
                <h4 className="form_title">{label['CreateTenant.FixedRateSetup.Text']}</h4>
                <div className="Customised_form_div">
                    {Select_Error_Message}
                    <Button id="createtenant_fixed_delete" type="button" className="btn btn-black" onClick={()=>this.DeleteFixedCharges()}>{label['ManageHolidays.Delete.Text'] !== undefined ? label['ManageHolidays.Delete.Text'] : "Delete"} </Button>
                    <Button id="createtenant_fixed_add" type="button" className="btn btn-success  TenantActionBtns" onClick={this.toggle}>{label['FixedRateSetup.AddFixedRate.Text'] !== undefined ? label['FixedRateSetup.AddFixedRate.Text'] : "Add Fixed Charge"} </Button>

                    <div className="table_container" style={{paddingRight:'15px'}}>
                        <Table striped responsive className="Custom_table table_border">
                            <tbody className="cell_container tenant_cell">
                                <tr>
                                    <th><input type="checkbox" className="FixedRt_header_Check_box" onClick={() => { SelectAllCheckboxes.selectAllCheckbox("fixedRt_child_check_box", "FixedRt_header_Check_box"); }} /></th>
                                    <th>{label['FixedRateSetup.Name.Text'] !== undefined ? label['FixedRateSetup.Name.Text'] : "Name"}</th>
                                    <th>{label['FixedRateSetup.Rate.Text'] !== undefined ? label['FixedRateSetup.Rate.Text'] : "Charge"}</th>
                                </tr>
                                {fixedCharges}
                            </tbody>
                        </Table>
                    </div>

                    <FormGroup row className="btns_group">
                        <Col sm={{ size: 10 }}>
                            <Button id="createtenant_fixed_back" className="btn-gray btn-md" onClick={this.goBack}> {label['Wizards.BackButton.Text']} </Button>
                            <Button id="createtenant_fixed_next" className="btn-success btn-md" onClick={this.goNext}>{label['Wizards.NextButton.Text']}</Button>
                        </Col>
                    </FormGroup>
                </div>

                <Modal isOpen={this.state.modal} toggle={this.toggle}  className={classnames({ classnames: this.props.className }, "ModalContainer short_modal")} >

                    <div className="AddFixedCharges_Modal">
                        {Error_Message}
                        <h4 className="Modal_form_title">{Header}</h4>
                        <div className="Modal_form_group ">
                            <Label className="AddFixedCharges_label">Name</Label>
                            <input className="AddFixedCharges_input default-input" defaultValue={FxName} type="text" id="createtenant_fixed_name" ref="FixedName" />
                        </div>

                        <div className="Modal_form_group">
                            <Label className="AddFixedCharges_label">Charge</Label>
                            <input className="AddFixedCharges_charges_input default-input" defaultValue={FxRate} type="text" id="createtenant_fixed_rate" ref="FixedRate" />&nbsp;&nbsp;{CurrencySym}
                        </div>
                        <FormGroup row className="btns_group">
                            <Col sm={{ size: 10 }}>
                                <Button id="createtenant_fixed_cancel" className="btn-gray btn-md ChangeLimits_Cancelbtn" onClick={this.toggle}> Cancel </Button>
                                <Button id="createtenant_fixed_save" className="btn-success btn-md ChangeLimits_Applybtn" onClick={this.onAddFixedCharge}>Apply </Button>
                            </Col>
                        </FormGroup>

                   
                    </div>
                </Modal>
                <Modal isOpen={this.state.deletemodal} deletemodal={this.deletemodal} className={classnames({ classnames: this.props.className }, "ModalContainer")} >
                    <DeleteConfirmation parentToChildData={["Delete Fixed Charge","You are about to delete a fixed charge. Do you want to continue?"]}  Delete = {this.Delete}   />
                </Modal>
            </div>
        );
    }
}

const mapStateToProps = state => {
    return {
        ClientSideComapnyState: state.manageTenant.ClientSideComapnyData,
        ClientSideFixedChargesState: state.manageTenant.ClientSideFixedChargesData,
        getLabels: state.CulturalLabelsRootReducer.LabelsBasedOnPreference,
        UserPreference_response: state.userPreferencesRootReducer.UserPreference
    };
};
const mapDispatchToProps = dispatch => {
    return {
        SaveFixedChargesforclient: (data) => dispatch(SaveFixedChargesforclient(data)),
        getAllResources: () => dispatch(getAllResources())
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(Tenants_FixedRates)